var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisinfection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_552_7943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#ECEFF1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_552_7943)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 60,
    r: 50,
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4892 42.0604H61.749V32.9003H52.5889V19.1601H61.749V10H75.4892V19.1601H84.6493V32.9003H75.4892V42.0604Z",
    fill: "#50DBAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4902 19.1601V10H68.6201V42.0604H75.4902V32.9003H84.6503V19.1601H75.4902Z",
    fill: "#48CC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3773 52.9571C95.5012 51.216 93.9938 49.9178 92.1328 49.3016C90.2697 48.6846 88.2852 48.8283 86.5433 49.7063L73.5907 56.2469C72.5428 53.485 69.872 51.5162 66.749 51.5162H58.025C54.5427 48.2153 49.6535 46.3406 44.445 46.3406C41.1594 46.3406 37.5213 47.6702 33.6729 49.1738V74.9026L64.2793 80.6631L93.2433 62.7447C94.9403 61.858 96.2017 60.3659 96.8012 58.5319C97.411 56.6668 97.2582 54.6829 96.3773 52.9571Z",
    fill: "#FFDAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7487 66.1749H46.9485V61.5948H66.7486C68.2573 61.5948 69.4847 60.3567 69.4847 58.8347C69.4847 57.3233 68.2573 56.0936 66.7486 56.0936H56.0803L55.4016 55.3684C52.7545 52.5401 48.761 50.9179 44.4446 50.9179C41.7528 50.9179 38.3372 52.2591 34.3824 53.8122C33.6689 54.0924 32.9424 54.3776 32.2036 54.6614L30.5615 50.3857C31.2896 50.1062 32.0053 49.825 32.7084 49.549C36.9136 47.8977 40.8857 46.3379 44.4446 46.3379C49.6531 46.3379 54.5424 48.2127 58.0246 51.5135H66.7486C70.7827 51.5135 74.0648 54.7979 74.0648 58.8347C74.0649 62.882 70.7827 66.1749 66.7487 66.1749Z",
    fill: "#FBCC94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 46.1125H33.6734V82.0596H19V46.1125Z",
    fill: "#457899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 64.0862H33.6734V82.0597H19V64.0862Z",
    fill: "#365C75"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisinfection);
export default __webpack_public_path__ + "static/media/disinfection.8b9f89c7e5a1c1e0dcde3423fe5507be.svg";
export { ForwardRef as ReactComponent };